export class AppConfig {
  private static readonly isLocal = process.env.NODE_ENV === "development";

  private static safeEnv = (value: string | undefined, key: string): string => {
    if (value !== undefined) {
      return value;
    }
    throw new Error(
      `${key} is not defined. Please set it in your environment variables.`,
    );
  };

  private static gatewayHost = (): string =>
    AppConfig.safeEnv(process.env.NEXT_PUBLIC_API_URL, "NEXT_PUBLIC_API_URL");

  private static readonly orderApiRoot =
    (this.isLocal && process.env.NEXT_PUBLIC_ORDER_URL) ||
    AppConfig.gatewayHost();

  private static readonly probeApiRoot =
    (this.isLocal && process.env.NEXT_PUBLIC_PROBE_URL) ||
    AppConfig.gatewayHost();

  private static readonly authApiRoot =
    (this.isLocal && process.env.NEXT_PUBLIC_AUTH_URL) ||
    AppConfig.gatewayHost();

  private static readonly paymentApiRoot =
    (this.isLocal && process.env.NEXT_PUBLIC_PAYMENT_URL) ||
    AppConfig.gatewayHost();

  private constructor() {}

  static ApiRoots = {
    Order: `${this.orderApiRoot}/order`,
    Probe: `${this.probeApiRoot}/probe`,
    OpenSearch: `${this.probeApiRoot}`,
    Auth: `${this.authApiRoot}/auth`,
    Payment: `${this.paymentApiRoot}/payment`,
    Gateway: AppConfig.gatewayHost(),
  };

  static ApiRowRoots = {
    Auth: AppConfig.safeEnv(
      process.env.NEXT_PUBLIC_AUTH_ROOT_URL,
      "NEXT_PUBLIC_AUTH_ROOT_URL",
    ),
    Web: AppConfig.safeEnv(
      process.env.NEXT_PUBLIC_WEB_URL,
      "NEXT_PUBLIC_WEB_URL",
    ),
  };
}
